import cx from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import { getOnEnter, RD_COMPONENTS } from '../../_utils';
import { Icon, IconColor, IconSize } from '../../icon';
import { InputBase, } from '../input-base';
import styles from './input-text.module.scss';
export const InputText = ({ ariaLabel, ariaLabelPrefix = '', ariaLabelSuffix = '', ariaPrefixHidden = false, ariaSuffixHidden = false, className, name, id, prefixIcon, suffixIcon, value = '', maxLength, onSuffixIconClick, onPrefixIconClick, onChange, formatter, parser, type = 'text', hasError = false, helperText, grow, suffix, prefix, suffixIconSize = IconSize.MEDIUM, suffixIconColor = IconColor.GRAY, suffixIconClassName, prefixIconClassName, inputClassName, inputRef, ...restProps }) => {
    const getFormattedValue = useCallback((val) => {
        if (formatter) {
            return formatter(val);
        }
        return val;
    }, [formatter]);
    const inputId = id || (name ? `input-${name}` : undefined);
    const [inputValue, setInputValue] = useState(getFormattedValue(value.slice(0, maxLength)));
    useEffect(() => {
        setInputValue(getFormattedValue(value.slice(0, maxLength)));
    }, [value, getFormattedValue, maxLength]);
    const handleSuffixIconClick = (event) => {
        if (onSuffixIconClick) {
            onSuffixIconClick(event);
        }
    };
    const handlePrefixClick = (event) => {
        if (onPrefixIconClick) {
            onPrefixIconClick(event);
        }
    };
    const handleChange = (event) => {
        let val = event.target.value;
        if (parser) {
            val = parser(val);
        }
        if (onChange) {
            onChange(event, val);
        }
        const formattedValue = getFormattedValue(val);
        setInputValue(formattedValue);
    };
    const getSuffixComponent = () => {
        if (suffixIcon) {
            return (React.createElement("div", { onClick: handleSuffixIconClick, className: cx(suffixIconClassName, styles.iconStyle, styles.suffixIcon), role: "button", "aria-label": ariaLabelSuffix, "aria-hidden": ariaSuffixHidden, tabIndex: ariaSuffixHidden ? -1 : 0, onKeyDown: getOnEnter(handleSuffixIconClick) },
                React.createElement(Icon, { color: suffixIconColor, size: suffixIconSize, id: suffixIcon })));
        }
        return null;
    };
    const getPrefixComponent = () => {
        if (prefixIcon) {
            return (React.createElement("div", { onClick: handlePrefixClick, className: cx(styles.iconStyle, styles.prefixIcon), role: "button", "aria-label": ariaLabelPrefix, "aria-hidden": ariaPrefixHidden, tabIndex: ariaPrefixHidden ? -1 : 0, onKeyDown: getOnEnter(handlePrefixClick) },
                React.createElement(Icon, { color: IconColor.GRAY, size: IconSize.MEDIUM, id: prefixIcon, className: prefixIconClassName })));
        }
        return null;
    };
    const containerClassNames = cx(className, styles.container, {
        [styles.grow]: grow,
    });
    return (React.createElement("div", { "data-radiant-v2": true, className: containerClassNames },
        React.createElement(InputBase, { type: type, name: name, onChange: handleChange, value: inputValue, "aria-label": ariaLabel, id: inputId, suffix: getSuffixComponent(), prefix: getPrefixComponent(), maxLength: maxLength, hasError: hasError, helperText: helperText, className: inputClassName, inputRef: inputRef, ...restProps }),
        maxLength && !helperText && (React.createElement("span", { className: styles.inlineMsgStyle },
            inputValue.length,
            "/",
            maxLength))));
};
InputText.RD_COMPONENT = RD_COMPONENTS.INPUT_NUMBER;
//# sourceMappingURL=input-text.js.map